import { Dialog, DialogTitle, MenuItem, Select, Stack } from "@mui/material";

import { Button, DialogActions, DialogContent } from "@mui/material";

import { luxonUtils } from "utils/luxonUtils";

import { DateRangeDateTimePicker } from "features/core/dateRange/DateRangeDateTimePicker";
import { useAppSelector, useAppDispatch } from "app/hooks";
import { liveStreamingSelectors } from "./store/selectors";
import { liveStreamingActions } from "./store/slice";
import { SitesAutocomplete } from "features/sites/SitesAutocomplete";

export interface EditSessionDialogProps {
    closeDialog: () => void;
}

export function EditSessionDialog(props: EditSessionDialogProps) {
    const dispatch = useAppDispatch();

    const session = useAppSelector(liveStreamingSelectors.selectSession);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={"lg"}
            disableEscapeKeyDown
            onClose={(event: object, reason: string) => {
                if (reason !== "backdropClick") {
                    props.closeDialog();
                }
            }}
            slotProps={{
                paper: {
                    component: "form",
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();

                        props.closeDialog();
                    },
                },
            }}
        >
            <DialogTitle>Edit session</DialogTitle>

            <DialogContent
                sx={{
                    minWidth: 500,
                }}
            >
                <Stack
                    spacing={2}
                    direction="column"
                >
                    <SitesAutocomplete
                        required
                        minSearchQueryCharacterLength={2}
                        onChange={(selectedSite) => {
                            dispatch(
                                liveStreamingActions.setSession({
                                    ...session,
                                    siteId: selectedSite?.id,
                                }),
                            );
                        }}
                        label="Site"
                        disableClearable
                        margin="dense"
                    />

                    <DateRangeDateTimePicker
                        label="Session start time"
                        value={
                            luxonUtils.fromIso(session.startTime, false) ?? null
                        }
                        onChange={(newValue) => {
                            dispatch(
                                liveStreamingActions.setSession({
                                    ...session,
                                    sessionStartTime:
                                        newValue?.toISO() ?? undefined,
                                }),
                            );
                        }}
                    />

                    <Select
                        value={session.origin}
                        label="Origin"
                        onChange={(newValue) => {
                            dispatch(
                                liveStreamingActions.setSession({
                                    ...session,
                                    origin: newValue.target.value,
                                }),
                            );
                        }}
                    >
                        <MenuItem value={"none"}>None</MenuItem>
                        <MenuItem value={"landing-page"}>Landing Page</MenuItem>
                    </Select>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    onClick={() => {
                        props.closeDialog();
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
